<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/elements-content -->

<section class="header_sec card">
  <div class="flex justify-content-between w-full align-items-center gap-3">
    <div class="custom_sd_btn">
      <p-button
        class="close_btn"
        (onClick)="sidebarOnOff()"
        icon="pi pi-align-left"></p-button>
    </div>
    <div class="global-search-wrapper">
      <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <div class="input_group">
          <input
            pInputText
            type="text"
            [value]="searchValue()"
            placeholder="Search modules, pages..."
            (input)="onSearch($event, searchOp)"
            (focus)="openIfHasData($event, searchOp)" />
        </div>
      </span>

      <p-overlayPanel
        #searchOp
        [dismissable]="true"
        styleClass="search-overlay">
        <p-listbox
          [options]="results()"
          optionLabel="title"
          [style]="{ width: '320px' }"
          (onChange)="navigate($event.value, searchOp)">
          <ng-template let-item pTemplate="item">
            <div class="search-item">
              <div class="title">{{ item.title }}</div>
              <div class="meta">{{ item.route }}</div>
            </div>
          </ng-template>
        </p-listbox>
      </p-overlayPanel>
    </div>
    <div class="flex gap-2 align-items-center">
      @if (
        (sidebarData &&
          sidebarData.subItemId &&
          sidebarMultiModules.includes(sidebarData.subItemId)) ||
        (sidebarData && sidebarData.parentId && sidebarData.parentId === 11)
      ) {
        <p-dropdown
          optionLabel="name"
          optionValue="language_code"
          [options]="languages()"
          placeholder="{{ 'language' | translate }}"
          [(ngModel)]="lang"
          (onChange)="onStatusChange($event)">
        </p-dropdown>
      }
      <div class="relative bell cursor-pointer">
        <div (click)="notificationOp.toggle($event); getNewNotification()">
          <i class="pi pi-bell" style="font-size: 1.7rem"></i>
          @if (profile) {
            <span class="dot">{{ profile.notification_unread || 0 }}</span>
          }
        </div>
      </div>
      <div
        routerLink="/profile"
        class="profile flex justify-content-center align-items-center gap-2"
        style="cursor: pointer">
        @if (profile) {
          <figure
            class="border-circle overflow-hidden w-3rem h-3rem flex justify-content-center align-items-center">
            <img
              [src]="
                profile.photo ? profile.photo : 'assets/images/profileig.png'
              "
              alt="Profile" />
          </figure>
          <a>{{ profile.name }}</a>
        }
      </div>
    </div>
  </div>

  <!-- notification -->
  <p-overlayPanel
    #notificationOp
    [style]="{
      width: '400px',
    }">
    <div class="mn_notification">
      <div
        class="title"
        style="
          position: fixed;
          top: 10px;
          font-weight: 600;
          font-size: 15px;
          display: flex;
          justify-content: space-between;
          gap: 174px;
        ">
        <h4>Notifications</h4>
        <div>
          @if (
            profile &&
            profile.notification_unread &&
            notificationData() &&
            notificationData().length > 0
          ) {
            <p-button
              (click)="updateNotification()"
              label="{{ 'Read All' | translate }}"
              [raised]="true"
              severity="contrast" />
          }
        </div>
      </div>
      @if (notificationData() && notificationData().length > 0) {
        <div class="notification-item1">
          <ul
            class=""
            infiniteScroll
            [infiniteScrollDistance]="1"
            [infiniteScrollThrottle]="50"
            [scrollWindow]="false"
            (scrolled)="onScrollingFinished()">
            @for (
              list of notificationData();
              track list.id;
              let index = $index
            ) {
              <li (click)="btn_redirect(list)">
                @if (!list.viewed) {
                  <div class="dot"></div>
                }
                <p>
                  {{ list.message
                  }}<span class="block">{{
                    list.created_at | date: 'dd/MM/YYYY hh:mm a'
                  }}</span>
                </p>
              </li>
            }
          </ul>
        </div>
      } @else if (notificationData() && notificationData().length === 0) {
        <div class="noDataFound">
          <figure>
            <img [src]="assetsConst.noNotification" alt="" />
          </figure>
          <p>
            {{ 'noNotifications' | translate }}
          </p>
        </div>
      }
    </div>
  </p-overlayPanel>

  <!-- notification -->
</section>
